import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { BarChart, Bar, XAxis, YAxis, Legend, Label, ResponsiveContainer } from 'recharts';

export default class TaxGraph extends React.Component {
  static init(id, props) {
    ReactDOM.render(
      <TaxGraph {...props} />,
      document.getElementById(id),
    );
  }

  constructor(props) {
    super(props);
    this.state = {
      taxSelection: 'pre-tax',
      taxData: props.preTaxData,
    };

    this.switchChartHandler = (e) => {
      if (e.currentTarget.classList.contains('pre-tax')) {
        this.setState({
          taxSelection: 'pre-tax',
          taxData: this.props.preTaxData,
        });
      } else if (e.currentTarget.classList.contains('post-tax')) {
        this.setState({
          taxSelection: 'post-tax',
          taxData: this.props.postTaxData,
        });
      }
    };
  }

  render() {
    let preTaxClass = 'tax-reform-switcher-item pre-tax';
    let postTaxClass = 'tax-reform-switcher-item post-tax';

    if (this.state.taxSelection === 'post-tax') {
      postTaxClass += ' item-selected';
    } else {
      preTaxClass += ' item-selected';
    }

    return (
      <div className="tax-graph-container">
        <div className="tax-graph-wrapper">
          <div className="tax-reform-switcher">
            <button className={preTaxClass} onClick={this.switchChartHandler} >
              <span>
                <div className="tax-reform-switcher-item-fill" />
              </span>
              <div className="tax-reform-text">
                Pre-tax Reform
              </div>
            </button>
            <button className={postTaxClass} onClick={this.switchChartHandler}>
              <span>
                <div className="tax-reform-switcher-item-fill" />
              </span>
              <div className="tax-reform-text">
                Post-tax Reform
              </div>
            </button>
          </div>
          <ResponsiveContainer width="100%" height={450}>
            <BarChart
              data={this.state.taxData}
              className="tax-graph-chart"
            >
              <XAxis dataKey="x" interval={0} angle={-60} textAnchor="end" strokeWidth={2}>
                <Label value="Cities" offset={100} position="bottom" fontSize="18" />
              </XAxis>
              <YAxis
                domain={[0, 50]}
                strokeWidth={2}
                unit="K"
                ticks={[10, 20, 30, 40, 50]}
              >
                <Label angle={-90} value="Taxable Income" position="left" style={{ textAnchor: 'middle', fontSize: 18 }}>
                  Taxable Income
                </Label>
              </YAxis>
              <Legend
                verticalAlign="top"
                margin={{ right: 40 }}
                iconSize={20}
                iconType="square"
              />
              <Bar dataKey="Uber Driver" fill="#F9A600" />
              <Bar dataKey="Restaurant Server" fill="#53C5EB" />
            </BarChart>
          </ResponsiveContainer>
          <div className="small-mobile-graph-label">
            Cities
          </div>
          <div className="graph-sources">
            Sources<sup>
              <a href="https://www.moving.com/tips/the-top-10-largest-us-cities-by-population/">14
              </a>
            </sup>
            &nbsp;
            <sup>
              <a href="https://www.fastcompany.com/3048563/this-is-how-much-uber-and-lyft-drivers-make-in-different-cities">15</a>
            </sup>
            &nbsp;
            <sup>
              <a href="https://www.glassdoor.com/Salaries/new-york-uber-driver-salary-SRCH_IL.0,8_IC1132348_KO9,20.htm">16</a>
            </sup>
            &nbsp;
            <sup>
              <a href="https://swz.salary.com/SalaryWizard/Food-Server-Institution-Salary-Details-Yuma-AZ.aspx">17</a>
            </sup>
          </div>
        </div>
      </div>
    );
  }
}

TaxGraph.propTypes = {
  preTaxData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  postTaxData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};



// WEBPACK FOOTER //
// ./src-react/TaxGraph/index.jsx